const redirects: { [key: string]: string } = {
    '/blog/daily-coffee-news-blk-bold-inks-nba-deal-releases-the-warm-up':
        '/blog',
    '/products/stocked-stickers': '/products/custom-stickers',
    '/products/coffee-stickers': '/products/custom-stickers',
    '/holiday-gifting': '/resources/design/design-lab',
    '/free-sample-pack': '/sample-pack',
    '/design-lab': '/resources/design/design-lab',
};

export default redirects;
